export { default } from './BedBuilderSlice'
